module.exports = __webpack_public_path__ + "static/media/deLang.9bce57a3.svg";